import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  Inject,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'alert-modal',
  templateUrl: '././alert.component.html',
  styleUrls: ['././alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlertModalComponent implements OnInit, OnDestroy {
  @Input('title') title: string;
  @Input('message') message: string;
  alertType: string = 'warn-btn';

  constructor(
    private dialogRef: MatDialogRef<AlertModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
    this.title = data.title;
    this.message = data.message;
    switch (true) {
      case /Error/.test(this.title):
        this.alertType = 'error-btn';
        break;
      case /Success/.test(this.title):
        this.alertType = 'success-btn';
        break;
      default:
        this.alertType = 'warn-btn';
        break;
    }
  }

  onClose() {
    this.dialogRef.close();
  }

  ngOnInit() {}

  ngOnDestroy() {}
}
